import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import { BlankResponseType, BlankType } from "@/models/blanksInput.model";
import WSelect from "@/components/form/w-select.vue";
import QuizUtils from "@/util/quizUtils";
import QuizQuestionCorrectionExplanation from "@/components/questions/QuizQuestionCorrectionExplanation.vue";
import WHtmlToolTip from "@/components/tooltip/w-html-tooltip.vue";
import QuizAnswersValidationAlert from "@/components/quiz/QuizAnswersValidationAlert.vue";
import quizUtils from "@/util/quizUtils";
let QuizBlanksQuestion = class QuizBlanksQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "userBlanksAnswers", void 0);
    _defineProperty(this, "questionCustomLabel", '');
    _defineProperty(this, "displayOverallVerdictIcon", false);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "displayAnswersValidationAlert", void 0);
    _defineProperty(this, "answersValidationState", void 0);
    _defineProperty(this, "BlankType", BlankType);
    _defineProperty(this, "realtimeBlanksAnswers", []);
  }
  mounted() {
    this.initBlanksRealtimeAnswers();
  }
  get LABEL_NB_MAX_CHARS() {
    return quizUtils.QUIZ_LABELS_NB_MAX_CHARS;
  }
  /**
   * init blanks answers to display
   * @private
   */
  initBlanksRealtimeAnswers() {
    if (this.userBlanksAnswers?.length) {
      this.realtimeBlanksAnswers = structuredClone(this.userBlanksAnswers);
    } else {
      this.realtimeBlanksAnswers = this.question.blanks.map(blank => {
        const blankAnswer = {
          blankId: blank.id,
          position: blank.position,
          type: blank.type === BlankType.TEXT ? BlankResponseType.EXACT_MATCH : BlankResponseType.MULTI_SELECT_OPTION,
          responseOptionId: null,
          responseOptionLabel: '',
          textResponse: ''
        };
        return blankAnswer;
      });
    }
  }
  get processedBlanksText() {
    const segments = [];
    const blankMap = new Map(this.question.blanks.map(b => [b.position, b]));
    // Find all blank matches at once
    const blankMatches = Array.from(this.question.blanksText.matchAll(/\[\?(\d+)\]/g));
    let lastIndex = 0;
    // Process each match in order
    for (const match of blankMatches) {
      // Add text before this blank
      if (match.index > lastIndex) {
        segments.push({
          type: 'text',
          content: this.question.blanksText.slice(lastIndex, match.index)
        });
      }
      // Add the blank
      const position = parseInt(match[1], 10);
      const blank = blankMap.get(position);
      if (blank) {
        segments.push({
          type: 'blank',
          blank
        });
      } else {
        // no blank definition found, Keep original text as fallback
        segments.push({
          type: 'text',
          content: match[0]
        });
      }
      lastIndex = match.index + match[0].length;
    }
    // Add remaining text
    if (lastIndex < this.question.blanksText.length) {
      segments.push({
        type: 'text',
        content: this.question.blanksText.slice(lastIndex)
      });
    }
    return segments;
  }
  get overallAnswersVerdictIcon() {
    return this.allAnswersAreCorrect ? 'check-circle-outline' : 'close-circle-outline';
  }
  get overallVerdictIconClass() {
    return this.allAnswersAreCorrect ? 'is-success' : 'is-failure';
  }
  get allAnswersAreCorrect() {
    return this.question.blanks.every(blank => QuizUtils.isBlankAnswerCorrect(blank, this.realtimeBlanksAnswers));
  }
  isMultipleAnswersTextBlank(blank) {
    return blank.type === BlankType.TEXT && blank.responses.filter(response => response.correctAnswer).length > 1;
  }
  getTextBlankAnswers(blank) {
    return blank.responses.filter(response => response.correctAnswer).map(response => response.label).join('/');
  }
  getBlankCorrectAnswer(blank) {
    return blank.responses.find(response => response.correctAnswer) || null;
  }
  getBlankCorrectAnswerValue(blank) {
    const correctAnswer = this.getBlankCorrectAnswer(blank);
    if (correctAnswer) {
      return this.getBlankHtmlValue(correctAnswer);
    }
    return '';
  }
  getBlankHtmlValue(blankResponse) {
    let htmlAnswer = '<div class="blank-select-content">';
    if (blankResponse.image) {
      htmlAnswer += `<img class="blank-select-image" src="${blankResponse.image.smallImagePath}"/><span class="blank-select-image-label">${blankResponse.image.imageLabel || ''}</span>`;
    } else {
      htmlAnswer += `<span class="blank-select-label">${blankResponse.label || ''}</span>`;
    }
    return htmlAnswer + `</div>`;
  }
  getBlankCorrectAnswerImagePath(blank) {
    return this.getBlankCorrectAnswer(blank)?.image?.imagePath || '';
  }
  answerStatusClass(blank) {
    if (this.isResultMode) {
      return QuizUtils.isBlankAnswerCorrect(blank, this.realtimeBlanksAnswers) ? 'is-success' : 'is-failure';
    }
    return '';
  }
  answerStatusIcon(blank) {
    return QuizUtils.isBlankAnswerCorrect(blank, this.realtimeBlanksAnswers) ? 'check-circle-outline' : 'close-circle-outline';
  }
  shouldDisplayTextBlankCorrection(blank) {
    return this.isResultMode && (!QuizUtils.isBlankAnswerCorrect(blank, this.realtimeBlanksAnswers) || this.isMultipleAnswersTextBlank(blank));
  }
  shouldDisplaySelectBlankCorrection(blank) {
    return this.isResultMode && !QuizUtils.isBlankAnswerCorrect(blank, this.realtimeBlanksAnswers);
  }
  getUserTextBlankAnswer(blankId) {
    const blankAnswer = this.realtimeBlanksAnswers.find(answer => answer.blankId === blankId);
    return blankAnswer?.textResponse || '';
  }
  getUserMultiSelectBlankAnswer(blankId) {
    const blankAnswer = this.realtimeBlanksAnswers.find(answer => answer.blankId === blankId);
    return blankAnswer?.responseOptionId ? `${blankAnswer?.responseOptionId}` : '';
  }
  getMultiSelectBlankOptions(blank) {
    return blank.responses.map(response => ({
      value: `${response.blankResponseId}`,
      label: response.label,
      htmlContent: this.getBlankImageOption(response),
      htmlLabel: this.getBlankHtmlValue(response)
    }));
  }
  getBlankImageOption(response) {
    return !response.image ? '' : `<div class="blank-select-image-option-container">
                                        <img class="blank-select-image-option" src="${response.image.imagePath}"/>` + (!response.image.imageLabel ? '' : ` <div class="blank-select-image-option-label"> ${response.image.imageLabel} </div>
                                    </div>`);
  }
  onTextBlankAnswerUpdate(blankId, value) {
    if (!this.isResultMode) {
      const userBlankAnswer = this.realtimeBlanksAnswers.find(blankAnswer => blankAnswer.blankId === blankId);
      if (userBlankAnswer) {
        userBlankAnswer.textResponse = value.trim();
        this.emitBlankAnswerUpdate();
      }
    }
  }
  onMultiSelectBlankAnswerUpdate(sourceBlank, choosedAnswerId) {
    if (!this.isResultMode) {
      let answerUpdated = false;
      this.realtimeBlanksAnswers.forEach(blankAnswer => {
        if (blankAnswer.blankId === sourceBlank.id) {
          blankAnswer.responseOptionId = parseInt(choosedAnswerId, 10);
          const sourceResponse = sourceBlank.responses.find(sourceResponse => sourceResponse.blankResponseId);
          if (sourceResponse) {
            blankAnswer.responseOptionLabel = sourceResponse.label;
          }
          answerUpdated = true;
        }
      });
      if (answerUpdated) {
        this.emitBlankAnswerUpdate();
      }
    }
  }
  getUserBlankAnswerImage(blank) {
    const blankAnswer = this.realtimeBlanksAnswers.find(blankAnswer => blankAnswer.blankId === blank.id);
    if (blankAnswer) {
      const userSelectedBlankAnswer = blank.responses.find(blankResponse => blankResponse.blankResponseId === blankAnswer.responseOptionId);
      if (userSelectedBlankAnswer) {
        return userSelectedBlankAnswer.image || null;
      }
    }
    return null;
  }
  getUserBlankAnswerImagePath(blank) {
    return this.getUserBlankAnswerImage(blank)?.imagePath || '';
  }
  emitBlankAnswerUpdate() {
    return this.realtimeBlanksAnswers;
  }
};
__decorate([Prop({
  required: true
})], QuizBlanksQuestion.prototype, "question", void 0);
__decorate([Prop({
  default: []
})], QuizBlanksQuestion.prototype, "userBlanksAnswers", void 0);
__decorate([Prop], QuizBlanksQuestion.prototype, "questionCustomLabel", void 0);
__decorate([Prop], QuizBlanksQuestion.prototype, "displayOverallVerdictIcon", void 0);
__decorate([Prop({
  default: false
})], QuizBlanksQuestion.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], QuizBlanksQuestion.prototype, "displayAnswersValidationAlert", void 0);
__decorate([Prop({
  default: null
})], QuizBlanksQuestion.prototype, "answersValidationState", void 0);
__decorate([Emit("blankAnswerUpdate")], QuizBlanksQuestion.prototype, "emitBlankAnswerUpdate", null);
QuizBlanksQuestion = __decorate([Component({
  components: {
    QuizAnswersValidationAlert,
    WHtmlToolTip,
    QuizQuestionCorrectionExplanation,
    WSelect,
    QuizQuestionLabel,
    WInput
  }
})], QuizBlanksQuestion);
export default QuizBlanksQuestion;